import { render, staticRenderFns } from "./OrderCreatorServiceSamples.vue?vue&type=template&id=64220741&"
import script from "./OrderCreatorServiceSamples.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorServiceSamples.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreatorServiceSamples.vue?vue&type=style&index=0&id=64220741&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports